/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {grantLocaleConsent} from '../api'

export const useMutationGrantLocaleConsent = createReactQueryMutationHook('grantLocaleConsent', grantLocaleConsent)
